import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Icon, Label, List, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";

const ChoosingCaregiversLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionKit = () => {
    return (
      <>
      <Grid stackable doubling columns="equal" padded='vertically'>
        <Grid.Column width={9}>
          <Segment raised className={styles.highlightsItemWhiteBG} >  
            <div style={{width: '100%', height: '100%', display: "inline-block"}}>
              <p className={styles.learnMoreAccordionText} > <br/>
                Asking around can help you find recommended caregivers before the time arises. Talk with the older adult's 
                healthcare providers, friends and family, and people in your community to see if they have any trusted references. 
                <br/><br/>
                Home care agencies can be helpful since all hiring and pay is done through the agency. They also typically offer 
                caregivers with a variety of skills and certifications and can match you with someone who fits the older adult's 
                needs. You can also do what is called a “private hire” where you and the older adult can choose the caregiver from 
                a list of candidates and have full control over the process. </p>
              <p className={styles.learnMoreAccordionTextEmphasis} > 
                The emergency kit should be tailored to the older adult's needs and should be kept in a waterproof container 
                that is easily accessible.</p><br/>
            </div>
          </Segment>  
        </Grid.Column>
        <Grid.Column >
          <Segment raised className={styles.highlightsItemWhiteBG} >  
            <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
              <List.Header className={styles.learnMoreBulletedListHeader} >Questions to Ask When Looking for a Caregiver:</List.Header>
              <>
                <List.Item header="Why are you interested in this position?" description="description" />
                <List.Item header="Can you tell me about your previous relevant positions and the duties you performed?" description="description" />
                <List.Item header="Is there anything about this job description that you are uncomfortable with?" description="description" />
                <List.Item header="How do you handle patients who may be angry or stubborn?" />
                <List.Item header="Do you have transportation? Are you comfortable driving to and from various appointments if needed?" description="description" />
                <List.Item header="Are you physically able to lift and transfer someone out of bed or a chair? (If applicable)" description="description" style={{bottomBorder: "none"}}/>
              </>
            </List>
          </Segment>  
        </Grid.Column>
      </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'help',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > How Do I Find Help? </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionKit()}/>)
      }
    },
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}PaidCaregiversLearnMore2.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(ChoosingCaregiversLearnMore);
